// 관세사 — 정산 이력 (Wave 5.4a, 2026-05-29)
//   백엔드: GET /clearance-broker/settlement-history, GET /clearance-broker/settlement-history/export
//   입금/확정 기록된 정산(월×업체) 목록 + 엑셀 내보내기.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';
function won(n) { return (Number(n) || 0).toLocaleString('ko-KR'); }

function CustomsBrokerHistory({ showToast }) {
  var st = showToast || function () {};
  var itemsState = useState([]); var items = itemsState[0]; var setItems = itemsState[1];
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];

  function load() {
    setLoading(true);
    authFetch(API + '/clearance-broker/settlement-history').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) setItems(d.items || []); setLoading(false); })
      .catch(function () { setLoading(false); });
  }
  useEffect(function () { load(); }, []);

  function exportExcel() {
    authFetch(API + '/clearance-broker/settlement-history/export')
      .then(function (r) { if (!r.ok) throw new Error('not ok'); return r.blob(); })
      .then(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a'); a.href = url; a.download = '관세사_정산이력.xlsx';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 1000);
      }).catch(function () { st('엑셀 생성 실패', 'err'); });
  }

  var totalBilled = items.reduce(function (s, r) { return s + (r.totalFee || 0); }, 0);
  var totalUnpaid = items.reduce(function (s, r) { return s + (r.unpaid || 0); }, 0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 14 }}>
        <div style={{ fontSize: 13, color: '#475569' }}>{'기록된 정산 ' + items.length + '건 · 청구합계 ' + won(totalBilled) + '원 · 미정산 '}<b style={{ color: totalUnpaid > 0 ? '#dc2626' : '#16a34a' }}>{won(totalUnpaid) + '원'}</b></div>
        <button onClick={exportExcel} disabled={items.length === 0} style={{ padding: '7px 16px', background: items.length === 0 ? '#cbd5e1' : '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: items.length === 0 ? 'not-allowed' : 'pointer' }}>{'📊 엑셀 내보내기'}</button>
      </div>

      {loading && <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</div>}
      {!loading && items.length === 0 && (
        <div style={{ padding: 50, textAlign: 'center', color: '#94a3b8', background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 32, opacity: 0.4 }}>{'📜'}</div>
          <div style={{ marginTop: 8 }}>{'정산 이력이 없습니다 (입금/확정 기록 시 누적)'}</div>
        </div>
      )}
      {!loading && items.length > 0 && (
        <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff' }}>
            <thead><tr style={{ background: '#f8fafc' }}>
              <th style={thS}>{'정산월'}</th><th style={thS}>{'업체'}</th>
              <th style={thRight}>{'정산합계'}</th><th style={thRight}>{'입금액'}</th><th style={thRight}>{'미정산'}</th>
              <th style={thCenter}>{'상태'}</th><th style={thS}>{'입금일'}</th>
            </tr></thead>
            <tbody>
              {items.map(function (r, i) {
                return (
                  <tr key={r.month + '_' + r.companyId + '_' + i} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={Object.assign({ fontWeight: 600 }, tdS)}>{r.month}</td>
                    <td style={tdS}>{r.companyName}</td>
                    <td style={tdRight}>{won(r.totalFee)}</td>
                    <td style={tdRight}>{won(r.paidAmount)}</td>
                    <td style={Object.assign({ color: r.unpaid > 0 ? '#dc2626' : '#94a3b8', fontWeight: r.unpaid > 0 ? 700 : 400 }, tdRight)}>{r.unpaid > 0 ? won(r.unpaid) : '-'}</td>
                    <td style={tdCenter}><span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: r.status === 'paid' ? '#16a34a' : '#ea580c', borderRadius: 10, padding: '2px 8px' }}>{r.status === 'paid' ? '완납' : '미정산'}</span></td>
                    <td style={tdS}>{r.paidDate || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

var thS = { padding: '10px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12, color: '#475569' };
var thCenter = Object.assign({}, thS, { textAlign: 'center' });
var thRight = Object.assign({}, thS, { textAlign: 'right' });
var tdS = { padding: '9px 12px', color: '#334155' };
var tdCenter = Object.assign({}, tdS, { textAlign: 'center' });
var tdRight = Object.assign({}, tdS, { textAlign: 'right' });

export default CustomsBrokerHistory;
